"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nativeSelectPaddingRight = exports.nativeSelectPaddingLeft = void 0;

var mobileStylesHelper_1 = __importDefault(require("../assets/mobileStylesHelper"));

var ZIndexLayers_1 = __importDefault(require("../common/ZIndexLayers"));

exports.nativeSelectPaddingLeft = 12;
exports.nativeSelectPaddingRight = 29;

var styles = function styles(_a) {
  var fontControl = _a.fontControl,
      fontFamily = _a.fontFamily,
      sizeControlHeight = _a.sizeControlHeight,
      colorText = _a.colorText,
      x6 = _a.x6;
  return __assign(__assign({
    select: __assign(__assign({
      fontFamily: fontFamily
    }, fontControl), {
      zIndex: ZIndexLayers_1.default.TRANSPARENT_NATIVE_SELECT,
      position: 'relative',
      outline: 'none',
      appearance: 'none',
      border: 'none',
      background: 'transparent',
      display: 'block',
      padding: "0 " + exports.nativeSelectPaddingRight + "px 0 " + exports.nativeSelectPaddingLeft + "px",
      lineHeight: sizeControlHeight + "px",
      height: sizeControlHeight,
      cursor: 'pointer',
      width: '100%',
      fallbacks: [{
        '-webkit-appearance': 'none'
      }, {
        '-moz-appearance': 'none'
      }],
      '&$inline': {
        display: 'inline-block'
      },
      '& .Select-control .Select-clear-zone': {
        display: 'none'
      },
      '& .Select-control': {
        margin: 0,
        position: 'relative',
        boxSizing: 'border-box'
      },
      '& .Select-multi-value-wrapper': {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        'white-space': 'nowrap'
      },
      '& .Select-value': {
        display: 'inline'
      },
      '& .Select-value-icon': {
        display: 'none'
      },
      '& .Select-input': {
        position: 'absolute'
      },
      '&::-ms-expand': {
        opacity: 0
      }
    }),
    arrow: {
      '& svg': {
        display: 'block',
        zIndex: ZIndexLayers_1.default.BASE,
        position: 'absolute',
        right: '3px',
        top: '0',
        bottom: '0',
        margin: 'auto 0'
      }
    }
  }, mobileStylesHelper_1.default({
    '& $select': {
      lineHeight: '46px',
      height: '46px'
    }
  })), {
    nativeSelect: {
      position: 'relative',
      '& select': {
        color: 'inherit'
      }
    },
    smallNativeSelect: {
      position: 'relative',
      height: x6 + "px",
      lineHeight: x6 + "px",
      '& $select': {
        lineHeight: x6 + "px",
        height: x6 + "px"
      }
    },
    inline: {},
    link: {},
    secondary: {},
    disableDelimiter: {},
    smallSelect: {
      height: x6 + "px",
      lineHeight: x6 + "px",
      minHeight: x6 + "px"
    },
    option: {
      color: colorText.normal
    }
  });
};

exports.default = styles;